import React, { Component } from "react";

//IMPORT IMAGES
import funenviIcon from '../../frontend/assets/img/Jainism/funenvi.png';
import expertteacherIcon from '../../frontend/assets/img/Jainism/expertteacher.png';
import service3Icon from '../../frontend/assets/img/icon/service-3.png';
import service4Icon from '../../frontend/assets/img/icon/service-4.png';
import serviceLine from '../../frontend/assets/img/Jainism/service-line.png';
import floatingBlueSVG from '../../frontend/assets/img/Jainism/floating blue svg.svg';
import starSmIcon from '../../frontend/assets/img/icon/star-sm.png';
import flagImage from '../../frontend/assets/img/Jainism/flag.PNG';

class Service extends Component {
    constructor(props) {
        super(props);
        this.state = {


        };
    }

    render() {
        return (
            <React.Fragment>
                <section className="service-section space">
                    <div className="container">

                        <div className="row gy-30">

                            <div className="col-lg-3 col-md-6 service-card wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-card-inner">
                                    <div className="sr-icon">
                                        <img src={funenviIcon} alt="icon" />
                                    </div>
                                    <h2 className="sr-title h4"><a href="#">Fun Environment </a></h2>
                                    <p className="sr-text">Activities such as Gahuli, singing, crafts, drawing, yoga, speech, debate, projects, research, science, history, geography, and personality development are organized for the overall development of the child.</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 service-card wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-card-inner">
                                    <div className="sr-icon">
                                        <img src={expertteacherIcon} alt="icon" />
                                    </div>
                                    <h2 className="sr-title h4"><a href="#">Expert Team Member</a></h2>
                                    <p className="sr-text">We have a team in which the majority of them are graduates and postgraduates; many are still in college pursuing their degrees. The graduate and postgraduate volunteers are currently working as business people, entrepreneurs, graphic designers, fashion designers, journalists, event planners, and teachers and working in the corporate sector as executives at different positions.</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 service-card wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-card-inner">
                                    <div className="sr-icon">
                                        <img src={service3Icon} alt="icon" />
                                    </div>
                                    <h2 className="sr-title h4"><a href="#">Many Locations</a></h2>
                                    <p className="sr-text">Ahmedabad 150 </p>
                                    <p className="sr-text">
                                        Mumbai 500 +</p>
                                    <p className="sr-text">
                                        Surat has 500 +</p>
                                    <p className="sr-text"> 
                                        Pune: 150+ students.</p>
                                </div>
                            </div>

                            <div className="col-lg-3 col-md-6 service-card wow fadeInUp" data-wow-delay="0.1s">
                                <div className="service-card-inner">
                                    <div className="sr-icon">
                                        <img src={service4Icon} alt="icon" />
                                    </div>
                                    <h2 className="sr-title h4"><a href="#">Programs & Event</a></h2>
                                    <p className="sr-text">SHASHAN STHAPANA DIVAS, YATRA PRAVAS, ANNUAL DAY, GIFT MALL, GAME MALL, We are pledged to inform you that we always participate in many Shashan events, such as Samuhik Rath Yatra, be it the Save Sikharji Save Giriraj Rally or any other Shashan seva activity.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="shape-mockup z-index-3 d-none d-xl-block" data-top="-4%" data-left="4%"><img
                        src={serviceLine} alt="shapes" /></div>
                    <div className="shape-mockup shapePulse z-index-negative  d-xl-block floating-header" data-top="27%" data-left="2%"
                        style={{ width: "10%" }}><img src={floatingBlueSVG} alt="shapes" /></div>
                    <div className="shape-mockup shapePulse rotate z-index-negative" data-top="19%" data-right="21%"><img
                        src={starSmIcon} alt="shapes" /></div>
                    <div className="shape-mockup shapePulse  z-index-negative flag-img" data-bottom="0%" data-right="5%"
                        style={{ width: "10%" }}><img src={flagImage} alt="shapes" /></div>
                </section>
            </React.Fragment >
        );
    }
}

export default Service;
